export default __webpack_public_path__ + "static/media/team2.997203d9.jpg";